import type { FunctionComponent } from 'react';
import { Box } from '@mantine/core';

export const StarDivider: FunctionComponent = () => (
  <Box
    ta="center"
    w="100%"
    ff="monospace"
    fz="md"
    lh="sm"
    style={{ overflow: 'hidden', whiteSpace: 'nowrap', letterSpacing: 'var(--letterspacing-wide)' }}
    aria-hidden="true"
  >
    {'*'.repeat(300)}
  </Box>
);
